// extracted by mini-css-extract-plugin
export default {"catalog__category":"PartCategory_catalog__category__tusAA","active":"PartCategory_active__R1NNy","category_label_quantity":"PartCategory_category_label_quantity__hRby+"};